import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import countries from '../mockedData/countries_list.json'
import store from '../store/store'

import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined' // add icon
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined' // remove icon


export default function NewRecipe() {
  const isMenuOpen = store((state) => state.isMenuOpen)
  const setIsMenuOpen = store((state) => state.setIsMenuOpen)

  const isUserLogged = store((state) => state.isUserLogged)


  const [newRecipe, setNewRecipe]  = useState({
    title: "",
    description: "",
    ingredients: [],
    country: "",
    origin: "",
    calories: 0,
    duration: 0,
    cost: 0,
    difficulty: "",
    instructions: "",
    image: "",
  })

  const navigate = useNavigate()

  const handleCost = (e) => {
    const value = e.target.value
    if (value < 1) {
      e.target.value = 1
    } else if (value > 300) {
      e.target.value = 300
    }

    setNewRecipe({...newRecipe, cost: value})
  }

  const handleDuration = (e) => {
    const value = e.target.value
    if (value < 1) {
      e.target.value = 1
    } else if (value > 1000) {
      e.target.value = 1000
    }

    setNewRecipe({...newRecipe, duration: value})
  }

  const handleCalories = (e) => {
    const value = e.target.value
    if (value < 1) {
      e.target.value = 1
    } else if (value > 3000) {
      e.target.value = 3000
    }

    setNewRecipe({...newRecipe, calories: value})
  }

  const handleTitle = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, title: value})
  }

  const handleDescription = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, description: value})
  }

  const handleIngredientsName = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe.ingredients, name: value})
  }

  const handleIngredientsQuantity = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe.ingredients, quantity: value})
  }

  const handleUtensils = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, utensils: value})
  }

  const handleCountry = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, country: value})
  }

  const handleOrigin = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, origin: value})
  }

  const handleInstructions = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, instructions: value})
  }

  const handleDifficulty = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, difficulty: value})
  }

  const handleAddIngredient = () => {
    console.log('add an ingredient') 
  }

  const handleAddUtensil = () => {
    console.log('add an utensil') 
  }

  const handleImageUrl = (e) => {
    const value = e.target.value
    setNewRecipe({...newRecipe, image: value})
  }

  const handleSubmit= (e) => {
    e.preventDefault()
    //check if every field has been submitted
    console.log('Please fill in all the fields')
    
    // if one field is not filled 
    // display error
      alert('form is valid')
  }

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // auto close the menu once the page is loaded
  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false)
    }
  },[])

  if (isUserLogged) {
    return (
      <main>
        <div id="new_recipe_container">
          
          <form id="new_recipe_form">

            <h3>Create your recipe</h3>

            {/* RECIPE NAME AND DESCRIPTION */}
            <div id='new_title_description_group'>

              {/* TITLE */}
              <div id='new_input_group'>
                <label htmlFor="new_title">Title</label>
                <input
                  type="text"
                  id='new_title'
                  name="title"
                  placeholder="Your recipe name"
                  onChange={(e) => handleTitle(e)}
                />
              </div>

              {/* DESCRIPTION */} 
              <div id='new_input_group'>
                <label htmlFor="new_description">Description</label>
                <input
                  type='text'
                  id="new_description"
                  name="description"
                  placeholder="Describe your recipe"
                  onChange={(e) => handleDescription(e)}
                />
              </div>

            </div>

            {/* INGREDIENTS AND UTENSILS*/}
            <div id='new_ingredients_utensils_group'> 

              {/* INGREDIENTS */}
              <div id='new_ingredients_group'>
                
                {/* NAME */}
                <div id='new_input_group'>
                  <label htmlFor="new_ingredients_name">Ingredient Name</label>
                  <input
                    type='text'
                    id="new_ingredients_name" className="new_recipe_input"
                    name="ingredient name"
                    placeholder='orange'
                    onChange={(e) => handleIngredientsName(e)}
                  />
                </div>

                {/* QUANTITY */}
                <div id='new_input_group'>
                  <label htmlFor="new_ingredients_quantity">Ingredient Quantity</label>
                  <div className='new_field_group'>
                    <input
                      type='text'
                      id="new_ingredients_quantity" className="new_recipe_input"
                      name="ingredient quantity"
                      placeholder='2 pcs'
                      onChange={(e) => handleIngredientsQuantity(e)}
                    />
                    <AddCircleOutlineOutlinedIcon id='new_recipe_icon' onClick={handleAddIngredient}/>
                  </div>
                </div>

              </div>

              {/* UTENSILS */}
              <div id='new_input_group'>
                <label htmlFor="new_utensil_name">Utensils</label>
                <div className='new_field_group'>
                  <input
                    type='text'
                    id="new_utensil_name" className="new_input"
                    name="utensil name"
                    placeholder='saucepan'
                    onChange={(e) => handleUtensils(e)}
                  />
                  <AddCircleOutlineOutlinedIcon id='new_recipe_icon' onClick={handleAddUtensil}/>
                </div>  
              </div>  

            </div>

            {/* ORIGIN AND COUNTRY */}  
            <div id='new_origin_country_group'>

              {/* COUNTRY */}
              <div id='new_input_group'>
                <label htmlFor="new_country">Country</label>
                <select
                  id="new_country"
                  name="country"
                  onChange={(e) => handleCountry(e)}
                  value={newRecipe.country}
                >
                  <option disabled value="Select a country" >Select a country</option>
                  {countries.map((country, i) => (
                    <option key={i} value={country.name} >{country.name}</option>
                  ))}
                </select>
              </div>

              {/* ORIGIN */}
              <div id='new_input_group'>
                <label htmlFor="new_origin">Origin</label>
                <textarea
                  type="text"
                  id="new_origin"
                  name="origin"
                  placeholder='Origins, historical or personal facts etc...'
                  onChange={(e) => handleOrigin(e)}
                />
              </div>

            </div>
            
            {/* DETAILS */}
            <div id='new_calories_duration_cost_difficulty_group'>
              
              {/* CALORIES */}
              <div id='new_input_group'>
                <label htmlFor="new_calories">Calories</label>
                <div className='new_field_group_small'>
                  <input
                    type="number"
                    min="0"
                    max="4000"
                    id="new_calories"
                    name="calories"
                    value={newRecipe.calories}
                    onChange={(e) => handleCalories(e)}
                  />
                  <p>kcal</p>
                </div>
              </div>

              {/* DURATION */}
              <div id='new_input_group'>
                <label htmlFor="new_duration">Duration</label>
                <div className='new_field_group_small'>
                  <input
                    type="number"
                    min="0"
                    max="480"
                    id="new_duration"
                    name="duration"
                    value={newRecipe.duration}
                    onChange={(e) => handleDuration(e)}
                  />
                  <p>min</p>
                </div>
              </div>

              {/* COST */}
              <div id='new_input_group'>
                <label htmlFor="new_cost">Cost</label>
                <div className='new_field_group_small'>
                  <input
                    type="number"
                    min="1"
                    max= "300"
                    id="new_cost"
                    name="cost"
                    value={newRecipe.cost}
                    onChange={(e) => handleCost(e)}
                  />
                  <p>$</p>
                </div>
              </div>

              {/* DIFFICULTY */}
              <div id='new_input_group'>
                <label htmlFor="new_difficulty">Difficulty</label>
                <select
                  id="new_difficulty"
                  name="difficulty"
                  onChange={(e) => handleDifficulty(e)}
                  value={newRecipe.difficulty}
                >
                  <option disabled value="Select a level">Select a level</option>
                  <option value="Easy" >Easy</option>
                  <option value="Medium" >Medium</option>
                  <option value="Hard" >Hard</option>
                </select>  
              </div>

            </div>

            {/* INSTRUCTIONS AND IMAGE */}
            <div id='new_instructions_image_group'> 

              {/* INSTRUCTIONS */}
              <div id='new_input_group'>
                <label htmlFor="new_instructions">Instructions</label>
                <input
                  type='text'
                  id="new_instructions"
                  name="instructions"
                  placeholder="format: 'peel the oranges; cut them in half; etc...'"
                  onChange={(e) => handleInstructions(e)}
                />
              </div>

              {/* IMAGE URL*/}
              <div className='new_input_group'>
                <div id='new_input_group'>  
                  <label htmlFor="new_image">Image URL</label>
                  <input
                    type="text"
                    id="new_image"
                    name="image"
                    placeholder='Image URL'
                    onChange={(e)=> handleImageUrl(e)}
                  />
                </div>
              </div>

            </div> 

            <div id='new_button_container'>
              <button id='new_submit_button' onClick={() => handleSubmit}>Create</button>
            </div>
          </form>


        </div>
      </main>
    )
  } else {
    navigate('/')
  }
}
